/* eslint-disable no-unused-vars */
export enum Routes {
  LOGIN = '/login',
  SIGNUP = '/signup',
  FORGOT_PASSWORD = '/forgot-password',
  FORGOT_PASSWORD_RESET = '/forgot-password/reset-password',
  SIGNUP_CONFIRM = '/signup-confirm',
  HOME = '/my-team',
  NOT_FOUND = '/404',
  // Customers
  HOME_CUSTOMERS = '/my-team/customers',
  // Vendors
  HOME_VENDORS = '/my-team/vendors',
  // Items
  HOME_ITEMS = '/my-team/items',
  // Purchase Orders
  HOME_PURCHASE_ORDERS = '/my-team/purchaseorders',
  // Orders
  HOME_ORDERS = '/my-team/orders',
  // Invoices
  HOME_INVOICES = '/my-team/invoices',
  // Packing Slips
  HOME_PACKING_SLIPS = '/my-team/packing-slips',
  // Payment Received
  HOME_PAYMENT_RECEIVED = '/my-team/payment-received',
  // Pay Vendor
  HOME_PAY_VENDOR = '/my-team/pay-vendor',
  // Reports
  HOME_REPORTS = '/my-team/reports',
  HOME_SALES_TAX_REPORT = '/my-team/reports/sales-tax',
  HOME_STATEMENT_REPORT = '/my-team/reports/statement',
  HOME_ACCOUNTS_PAYABLE_REPORT = '/my-team/reports/accounts-payable',
  HOME_ACCOUNTS_RECEIVABLE_REPORT = '/my-team/reports/accounts-receivable',
  HOME_CUSTOMER_REPORT = '/my-team/reports/customer',
  HOME_VENDOR_REPORT = '/my-team/reports/vendor',
  HOME_SALES_ORDER_REPORT = '/my-team/reports/sales-order',
  // Help
  HOME_HELP = '/my-team/help',
}

export const publicRoutes: string[] = [
  Routes.LOGIN,
  Routes.SIGNUP,
  Routes.FORGOT_PASSWORD,
  Routes.SIGNUP_CONFIRM,
];

export const privateRoutes: string[] = [
  Routes.HOME,
  Routes.HOME_CUSTOMERS,
  Routes.HOME_VENDORS,
  Routes.HOME_ITEMS,
  Routes.HOME_ORDERS,
  Routes.HOME_INVOICES,
  Routes.HOME_PACKING_SLIPS,
  Routes.HOME_PAYMENT_RECEIVED,
  Routes.HOME_PAY_VENDOR,
  Routes.HOME_REPORTS,
  Routes.HOME_SALES_TAX_REPORT,
  Routes.HOME_STATEMENT_REPORT,
  Routes.HOME_ACCOUNTS_PAYABLE_REPORT,
  Routes.HOME_ACCOUNTS_RECEIVABLE_REPORT,
  Routes.HOME_CUSTOMER_REPORT,
  Routes.HOME_VENDOR_REPORT,
  Routes.HOME_SALES_ORDER_REPORT,
  Routes.HOME_HELP,
];

export const TOAST_DEFAULT_TIMEOUT_MS = 6000;
